import type { SVGProps } from 'react'

const Moon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17.5 10.523A7.5 7.5 0 1 1 9.477 2.5a5.833 5.833 0 0 0 8.023 8.023Z" />
  </svg>
)

export default Moon
